//let itemArray = JSON.parse(localStorage.getItem("addObject")) || []
$(document).ready(function () {
  var bodyHeight = $(window).height();
  var headerHeight = $(".header").height();

  $("body").on("click", "#logoutBtn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    localStorage.clear();
    window.location.href = location.origin;
  });

  $(window).scroll(function (e) {
    if ($(this).scrollTop() >= 71) {
      $("body, section.content").addClass("headerScrolled");
      $("body #iframe").parent().addClass("makeFieldSticky");
      $("body #iframe").addClass("animate");
    } else {
      $("body").removeClass("headerScrolled");
      $("body #iframe").parent().removeClass("makeFieldSticky");
      $("body #iframe").removeClass("animate");
    }
  });

  if ($("body").hasClass("bg-black")) {
    $("body").removeClass("bg-black");
  }

  $("body").on("click", ".betSlipHeader", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (e.target.getAttribute("id") != "userSelect") {
      if ($(e.currentTarget).parent().hasClass("slideDown")) {
        $(e.currentTarget).parent().removeClass("slideDown");
        $("body").removeClass("betSlipOpened");
      } else {
        $(e.currentTarget).parent().addClass("slideDown");
        $("body").addClass("betSlipOpened");
      }
    }
  });

  $("body").on("click", ".closeModal", function () {
    $(".betSlip").addClass("hideMe");
    $(".betSlip").removeClass("slideDown");
    $("body").removeClass("betSlipOpened");
    const itemArrayA = JSON.parse(localStorage.getItem("addObject")) || [];
    itemArray = [];
    localStorage.setItem("addObject", JSON.stringify(itemArray));
    localStorage.removeItem("coefHasChanged");
    $("body .betSlipSingleItem").remove();
    $("body .bettingBtn").removeClass("betSlipAdded");
    $("body .betCount span").text(0);

    function calculatePrice(value) {
      if (!value) {
        value = document.getElementById("placeBetAreaValue").value;
      }
      var totalValue = 1;
      var totalKoef = 1;

      itemArray.forEach((item) => {
        totalValue = totalValue * item.coefVal;
      });
      itemArray.forEach((item) => {
        totalKoef = totalKoef * +item.coefVal;
      });
      totalValue = totalValue * value;

      const size = $("#systemBtn").val();

      if (size && size !== "-1") {
        const odds = [];

        itemArray.forEach((element) => {
          odds.push(element.coefVal);
        });

        var s = getCombinations(odds, size);
        var r = treatCombinations(s);

        $("#winningPrice")[0].innerHTML = `${Math.round(r.min * 100) / 100} / ${
          Math.round(r.newMax * 100) / 100
        }`;
      } else {
        document.getElementById("winningPrice").textContent =
          parseFloat(totalValue).toFixed(2);
      }

      $("body .koefVal").text((+totalKoef).toFixed(2));
    }
    calculatePrice();

    if (itemArrayA) {
      itemArrayA.forEach((item) => {
        const event = new CustomEvent("leaveRoom", {
          detail: item.gameId,
        });
        window.dispatchEvent(event);
      });
    }

    $("body .hideThisWhenClear").removeClass("hidden");
  });

  // $("body").on("click", ".mainLeftMenuItem a", function () {
  //   $("body").removeClass("menuOpened");
  // });

  $("body").on("click", ".headerHide", function () {
    $("body").addClass("headerScrolledStatic");
  });

  $(window).scroll(function (e) {
    if ($(this).scrollTop() == 0) {
      $("body").removeClass("headerScrolledStatic");
    }
  });

  let scrollVar = 0;
  $("body .scrollHelper")
    .children(".slotsItem")
    .each(function (i, item) {
      scrollVar += $(item).outerWidth();
    });

  $("body .scrollHelper").css({
    width: scrollVar + "px",
  });

  let scrollVar2 = 0;
  $("body .scrollHelper1")
    .children(".slotsItem")
    .each(function (i, item) {
      scrollVar2 += $(item).outerWidth();
    });

  $("body .scrollHelper1").css({
    width: scrollVar2 + "px",
  });

  let scrollVar3 = 0;
  $("body .scrollHelper2")
    .children(".slotsItem")
    .each(function (i, item) {
      scrollVar3 += $(item).outerWidth();
    });

  $("body .scrollHelper2").css({
    width: scrollVar3 + "px",
  });

  let scrollVar4 = 0;
  $("body .scrollHelper3")
    .children(".slotsItem")
    .each(function (i, item) {
      scrollVar4 += $(item).outerWidth();
    });

  $("body .scrollHelper3").css({
    width: scrollVar4 + "px",
  });

  $("body").on("click", ".rouletteBtn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (
      !localStorage.getItem("access_token") ||
      localStorage.getItem("access_token") == ""
    ) {
      alert("Login!");
      return;
    }

    const gameName = "LuxRoulette";
    console.log(
      `${
        location.origin
      }/casino/index?game=${gameName}&u=${localStorage.getItem("access_token")}`
    );
    var win = window.open(
      `${
        location.origin
      }/casino/index?game=${gameName}&u=${localStorage.getItem(
        "access_token"
      )}`,
      "_blank"
    );
    if (win) {
      //Browser has allowed it to be opened
      win.focus();
    } else {
      //Browser has blocked it
      alert("Please allow popups for this website");
    }
  });
});
